/**
 * Processes raw inverter metrics data
 * @param {Array<{
 *   timestamp: number,
 *   current: number,
 *   voltage: number,
 *   error: number,
 *   temp_ambient: number,
 *   temp_heatsink: number,
 *   data_points?: number,
 *   hour_timestamp?: number
 * }>} data - Raw inverter metrics data
 * @returns {Array} - Processed data with current divided by 10
 */
export const processInverterData = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.map(record => ({
    ...record,
    current: record.current ? record.current / 10 : 0,  // Divide current by 10
  }));
};

/**
 * Formats the processed data for chart display
 * @param {Array} processedData 
 * @returns {Object} Formatted data for charts
 */
export const formatChartData = (processedData) => {
  return {
    timestamps: processedData.map(item => item.timestamp),
    metrics: {
      current: processedData.map(item => item.current),
      voltage: processedData.map(item => item.voltage),
      error: processedData.map(item => item.error),
      tempAmbient: processedData.map(item => item.temp_ambient),
      tempHeatsink: processedData.map(item => item.temp_heatsink)
    }
  };
};
